import { FORMS } from '../../features/accounting/forms/formConsts';
import SectionList from '../../components/sectionBoxes/SectionList';

const Form = () => {
  return (
    <div className="h-full flex flex-column">
      <div className="mt-4 mb-3 mx-8">
        <SectionList boxes={FORMS} />
      </div>
    </div>
  );
};

export default Form;
